import * as types from "../actions/actionTypes";
import initialState from "./initialState";
import { CurrentMentorsActions } from "../actions/currentClientActions";
import { Mentor } from "../../../Shared/GeneratedTypes";
import { LiveSwitchAction } from "../../../LiveSwitch/liveSwitchActions";

// type actions = CurrentMentorsActions & LiveSwitchAction
export default function mentorReducer(
    state = initialState.mentor as any,
    action: CurrentMentorsActions | LiveSwitchAction
): Mentor | null {
    switch (action.type) {
        case types.LOAD_CURRENT_MENTORS_BY_ID_SUCCESS: {
            return action.session.order.assignedMentor || null;
        }
        case types.ENTERED_INTO_QUEUE_SUCCESS:
        case types.CHECK_QUEUE_PLACEMENT_SUCCESS: {
            if (action.queuePlacementResult.mentor) {
                return action.queuePlacementResult.mentor;
            }
        }
    }
    return state;
}
